// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"236":"ea669b20e1d598ed","888":"97293f61164f96cd"}[chunkId] + ".css";
};